import MessagesApp from "../MessagesApp";
export default function SellerMessages() { return <MessagesApp role="seller" />; }
